/** Route-aware active state for sidebar items (Reports, Dashboard, GST paths). */

const SPECIAL_NAMES = new Set([
  'Reports',
  'Dashboard',
  'GST Compliance',
  'Statutory Dues',
]);

export function isSidebarNavItemActive(
  itemName: string,
  isActive: boolean,
  pathname: string
): boolean {
  if (itemName === 'Reports') {
    return (
      isActive ||
      pathname.startsWith('/dashboard/reports/advanced') ||
      pathname.startsWith('/reports/advanced')
    );
  }

  if (itemName === 'Dashboard') {
    return (
      isActive &&
      !pathname.startsWith('/dashboard/reports/advanced') &&
      !pathname.startsWith('/reports/advanced')
    );
  }

  if (itemName === 'GST Compliance') {
    return isActive && pathname === '/gst';
  }

  if (itemName === 'Statutory Dues') {
    return isActive && pathname === '/gst/statutory';
  }

  if (SPECIAL_NAMES.has(itemName)) {
    return false;
  }

  return isActive;
}
